import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return <section className="container mx-auto px-4 py-16 text-center">
    <Helmet><title>Không tìm thấy trang | Nền Móng Việt Nam</title><meta name="robots" content="noindex,follow" /></Helmet>
    <h1 className="text-2xl font-bold text-primary mb-4">Không tìm thấy trang</h1>
    <p className="mb-6">Đường dẫn này không tồn tại hoặc nội dung đã được chuyển.</p>
    <Link to="/" className="inline-block rounded-lg bg-primary px-6 py-3 text-white">Về trang chủ</Link>
  </section>;
}
